"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdContent = exports.getFailoverCreativeUrl = exports.getEncodedSlotOptions = exports.getContentSize = void 0;
function getContentSize(properties, response) {
    var _a;
    const parseSize = (size) => {
        const [width, height] = size.split('x');
        return {
            width: parseInt(width, 10),
            height: parseInt(height, 10)
        };
    };
    if (response && response.size) {
        return parseSize(response.size);
    }
    if ((_a = properties._opts) === null || _a === void 0 ? void 0 : _a._imp_banner_size) {
        return parseSize(properties._opts._imp_banner_size);
    }
    return { width: 768, height: 90 };
}
exports.getContentSize = getContentSize;
function getEncodedSlotOptions(_opts) {
    const options = _opts || {};
    const opts = Object.keys(options).reduce((acc, key) => {
        if (key !== 'content' && key !== 'b64') {
            acc[key] = options[key];
        }
        return acc;
    }, {});
    try {
        return JSON.stringify(opts);
    }
    catch (ignored) { }
    return '{}';
}
exports.getEncodedSlotOptions = getEncodedSlotOptions;
function getFailoverCreativeUrl(adsDomain, response) {
    const failoverUrl = response === null || response === void 0 ? void 0 : response.failover_url;
    const failoverQueryString = response === null || response === void 0 ? void 0 : response.failover_query_string;
    if (failoverUrl) {
        return 'https://' + adsDomain + failoverUrl;
    }
    else if (failoverQueryString) {
        const errorPageURL = failoverQueryString.toString().indexOf('msgCode=1005') !== -1
            ? 'https://cdn.revjet.com/~cdn/Content/static/406.html'
            : 'https://cdn.revjet.com/~cdn/Content/static/failover.html';
        return errorPageURL + '?' + failoverQueryString;
    }
    return null;
}
exports.getFailoverCreativeUrl = getFailoverCreativeUrl;
function getAdContent(properties, response) {
    var _a, _b;
    const failoverUrl = response === null || response === void 0 ? void 0 : response.failover_url;
    const failoverQueryString = response === null || response === void 0 ? void 0 : response.failover_query_string;
    if (failoverUrl || failoverQueryString) {
        const adsDomain = ((_a = properties._opts) === null || _a === void 0 ? void 0 : _a.custom_domain) || 'ads.revjet.com';
        const failoverCreativeUrl = getFailoverCreativeUrl(adsDomain, response);
        if (failoverCreativeUrl) {
            const { width, height } = getContentSize(properties, response);
            return ('<!DOCTYPE html>\n<html>\n' +
                '<head>\n<style>* {padding:0;margin:0;}</style>\n</head>\n' +
                '<body style="background-color: #fff;">\n' +
                '<iframe ' +
                [
                    `src="${failoverCreativeUrl}"`,
                    `allowtransparency="false"`,
                    `frameborder="0"`,
                    `marginwidth="0"`,
                    `marginheight="0"`,
                    `scrolling="no"`,
                    `width="${width}"`,
                    `height="${height}"`,
                    `style="border:0;vertical-align:bottom;width:${width}px;height:${height}px;"`
                ].join(' ') +
                '></iframe>\n</body>\n</html>');
        }
    }
    return ((_b = properties._opts) === null || _b === void 0 ? void 0 : _b.content) || (response === null || response === void 0 ? void 0 : response.content) || '';
}
exports.getAdContent = getAdContent;
//# sourceMappingURL=commons.js.map